import { belgeGunu } from "./is-tarihi.js";
import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). */
export const WELDMAP_BELGE_TURU = "weldmap";
/** Okunan Documents türü (GELEN_TURLERI anahtarı, "Weld map (PDF)"). */
export const WELDMAP_GELEN_TURU = "weldmap";
export const weldMapGelenTuruMu = (t) => t === WELDMAP_GELEN_TURU;
/** Olay kaydında nesne tipi (nesneId = weld_map_kaydi.id). */
export const WELDMAP_OLAY_NESNESI = "weld_map_kaydi";
/**
 * Okunan hafif excel'in belge ailesi. "Weld map" ailesiyle eşit değildir: Riser Documentation, kanıt zinciri ve aile işlemleri bu adı almaz
 * (weld map PDF'inin kendi ailesi "Weld map" değişmez).
 */
export const WELDMAP_GIRDI_AILESI = "Weld-map-input";
/** DOCUMENT sayfasındaki "Document type" değeri. */
export const WELDMAP_EXCEL_ADI = "Weld map";
/** Bir weld map'te en çok kaynak (farklı `Weld` sayısı). */
export const WELDMAP_KAYNAK_EN_COK = 60;
/** Bir kaynakta en çok paso satırı (`Row`). */
export const WELDMAP_PASO_EN_COK = 30;
/** Okuma işi kodu ("WMAP-5D20B7E1"): "WM-" uyarı kodlarıyla karışmasın diye "WMAP". */
export const weldMapKodu = (kayitId) => `WMAP-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/**
 * Başlık alanları (DOCUMENT, sabit sıra; sözleşme §5.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. `etiket` hem ekran metni hem
 * DOCUMENT'teki Field adıdır (S2).
 */
export const WELDMAP_ALANLARI = [
    { alan: "kalem", etiket: "Item description", kimlik: false }, { alan: "riser_no", etiket: "Riser number", kimlik: true },
    { alan: "riser_sn", etiket: "Riser serial number", kimlik: true }, { alan: "hat_sn", etiket: "Line serial number", kimlik: true },
    { alan: "hat_sn_2", etiket: "Line serial number (page 2)", kimlik: true }, { alan: "pin_sn", etiket: "New pin SN", kimlik: true },
    { alan: "box_sn", etiket: "New box SN", kimlik: true }, { alan: "grafik_sayfalari", etiket: "PWHT chart pages", kimlik: false },
];
/** Kaynak düzeyi alanlar (ROWS, `Row` boş; sabit sıra; sözleşme §5.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. */
export const WELDMAP_KAYNAK_ALANLARI = [
    { alan: "cizim_ucu", etiket: "Drawn end", kimlik: false }, { alan: "cizim_ucu_2", etiket: "Drawn end (page 2)", kimlik: false },
];
/**
 * Satır alanları (ROWS, `Row` 1…n; sabit sıra; sözleşme §5.3, sürüm 1). Her alanın tüketicisi sözleşmede yazılıdır. Kaynakçı baş harf ya da koddur;
 * kişinin kimlik no'su alınmaz. Run, proses, çap, amper, volt ve gaz okunmaz (K24 gösterimi görüntüleyicidedir).
 */
export const WELDMAP_PASO_ALANLARI = [
    { alan: "wps", etiket: "WPS", kimlik: false }, { alan: "wps_rev", etiket: "WPS revision", kimlik: false },
    { alan: "sarf_tipi", etiket: "Consumable type", kimlik: false }, { alan: "lot", etiket: "Lot", kimlik: true },
    { alan: "kaynakci", etiket: "Welder", kimlik: true }, { alan: "tarih", etiket: "Date", kimlik: false },
    { alan: "on_isitma", etiket: "Preheat", kimlik: false }, { alan: "paso_arasi", etiket: "Interpass", kimlik: false },
];
/** Alanın ekran adı (üç listede aranır); bilinmiyorsa alanın kendisi. */
export const weldMapEtiketi = (alan) => [...WELDMAP_ALANLARI, ...WELDMAP_KAYNAK_ALANLARI, ...WELDMAP_PASO_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** ROWS başlığı (uzun biçim: her hücre bir satır). */
export const WELDMAP_SATIR_BASLIKLARI = ["Weld", "Row", "Field", "Value", "As written", "Page", "Certainty"];
const ISO_GUN = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Kaynağın tek günü (Z20): yalnız kaynağın bütün paso satırları aynı günü KESİN yazıyorsa ve gün bugünden sonra değilse önerilir. Emin olunmayan
 * değer girilmez: bir satır şüpheli ya da boşsa öneri yoktur; çok günlü kaynakta tek gün seçilmez. `bugun` Europe/Istanbul günü ("YYYY-MM-DD").
 */
export function kaynakTarihiOnerisi(k, bugun) {
    const tarihler = k.pasolar.map((p) => p.degerler.find((d) => d.alan === "tarih") ?? null);
    if (!tarihler.length || tarihler.every((d) => !d || d.kesinlik === "bos"))
        return { gun: null, neden: "yok", gunler: [] };
    if (tarihler.some((d) => !d || d.kesinlik !== "kesin" || d.deger === null))
        return { gun: null, neden: "suphe", gunler: [] };
    const gunler = [];
    for (const d of tarihler) {
        const v = d.deger.trim();
        const g = ISO_GUN.test(v) ? belgeGunu(v) : null;
        if (!g)
            return { gun: null, neden: "bicim", gunler: [] };
        if (!gunler.includes(g))
            gunler.push(g);
    }
    gunler.sort();
    if (gunler.length > 1)
        return { gun: null, neden: "farkli", gunler };
    if (gunler[0] > bugun)
        return { gun: null, neden: "gelecek", gunler };
    return { gun: gunler[0], neden: null, gunler };
}
/** `belge_deger_onayi.alan`: kaynak tarihinin kaydı ("kaynak_tarihi_w3"). */
export const KAYNAK_TARIHI_ALANI = (no) => `kaynak_tarihi_w${no}`;
/** `belge_deger_onayi.sonuc` (Z24): değer kişinin onayıyla kayda yazıldı (weld map kaynak tarihi `weld.kaynak_tarihi`'ne). */
export const KAYDA_YAZILDI = "kayda_yazildi";
/* ---------------- yardımcılar (Z8, Z15, Z17) ---------------- */
const TR_LATIN = { "İ": "I", "ı": "i", "Ş": "S", "ş": "s", "Ç": "C", "ç": "c", "Ğ": "G", "ğ": "g", "Ö": "O", "ö": "o", "Ü": "U", "ü": "u" };
const latin = (s) => s.replace(/[İıŞşÇçĞğÖöÜü]/g, (c) => TR_LATIN[c] ?? c).normalize("NFD").replace(/\p{M}/gu, "").toUpperCase();
/** Baş harf anahtarı (Z17): harf dışı atılır, Türkçe harf Latin karşılığına, büyük harf ("M.K" → "MK", "ş.ç" → "SC"). */
export const basHarfAnahtari = (s) => latin(s).replace(/[^A-Z]/g, "");
/** Adın baş harfleri (Z17): her kelimenin ilk harfi, aynı dönüşümle ("A. Sample" → "AS", "Ayşe Gül Örnek" → "AGO"). */
export const adBasHarfleri = (ad) => ad.split(/[\s.]+/).map((k) => basHarfAnahtari(k).charAt(0)).join("");
/** Çizimdeki kaynak ucu (Z8, WM-08): "box" | "pin" (büyük-küçük harf duyarsız); değilse null. */
export const cizimUcu = (deger) => {
    const v = (deger ?? "").trim().toLowerCase();
    return v === "box" ? "box" : v === "pin" ? "pin" : null;
};
/** İşteki kaynağın ucu (`weld.joint`): "Box to pipe butt" → box, "Pin to pipe butt" → pin; "Pipe to pipe butt" ve boş null. */
export const jointUcu = (joint) => {
    const v = (joint ?? "").trim().toLowerCase();
    return v.startsWith("box to") ? "box" : v.startsWith("pin to") ? "pin" : null;
};
/**
 * İki sayfanın çizim ucu (Z46; karşılaştırma ve kart ortak): `farkli` ikisi de dolu ve farklıysa; `uc` farklı değilse `u1 ?? u2`, farklıysa null
 * (hangi ucun doğru olduğu belirsizdir; kişi sayfaya bakar). `s1`/`s2` sayfa no'larıdır (kartın metni için; karar onlara bakmaz).
 */
export function cizimUcuMetni(u1, s1, u2, s2) {
    const farkli = u1 !== null && u2 !== null && u1 !== u2;
    return { uc: farkli ? null : u1 ?? u2, farkli };
}
/** °C sayı (Z8): "100", "100 °C", "100,5" → sayı; biçim dışı null. */
export const santigrat = (deger) => {
    const v = (deger ?? "").trim();
    if (!/^\d+(?:[.,]\d+)?\s*(?:°\s*C)?$/i.test(v))
        return null;
    const n = Number(/^\d+(?:[.,]\d+)?/.exec(v)[0].replace(",", "."));
    return Number.isFinite(n) ? n : null;
};
/** WPS rev'inin karşılaştırma biçimi: büyük harf; "REV", nokta ve boşluk atılır ("rev 2", "REV.2" → "2"). */
export const revSade = (s) => (s ?? "").toUpperCase().replace(/REV/g, "").replace(/[\s.:]+/g, "");
/** Sarf tipinin karşılaştırma biçimi: büyük harf, boşluksuz. */
export const tipSade = (s) => (s ?? "").toUpperCase().replace(/\s+/g, "");
/** Üretilen kodlar (üretim sırası). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). */
export const WELDMAP_UYARI_KODLARI = [
    "KIM-01", "KIM-02", "KIM-07", "KIM-08", "KIM-03", "KIM-04", "WM-06", "WM-08", "WM-07", "WPS-02", "WM-03", "WM-02", "SARF-03", "WPS-06", "WPQ-06", "WPQ-03", "WM-05", "GEN-11", "GEN-15", "GEN-09",
];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). KIM-01 f dışındaki KIM kalıpları hidrotestinkiyle aynı nesnelerdir. */
export const WELDMAP_UYARI_KALIPLARI = {
    "KIM-01": { ...HIDROTEST_UYARI_KALIPLARI["KIM-01"], f: "Riser SN {0} on the document is riser {1}'s. You are filing it to riser {2}." },
    "KIM-02": HIDROTEST_UYARI_KALIPLARI["KIM-02"], "KIM-03": HIDROTEST_UYARI_KALIPLARI["KIM-03"], "KIM-04": HIDROTEST_UYARI_KALIPLARI["KIM-04"],
    "KIM-07": HIDROTEST_UYARI_KALIPLARI["KIM-07"], "KIM-08": HIDROTEST_UYARI_KALIPLARI["KIM-08"],
    "WM-06": "Weld count {0} differs from the cut plan ({1}).",
    "WM-08": {
        is: "Weld drawn at the {0} end; the job has it at the {1} end.",
        sayfalar: "Weld drawn at the {0} end on page {1} and at the {2} end on page {3}.",
    },
    "WM-07": {
        wps: "Fit-up value differs from the weld map: WPS {0} / {1}.",
        kaynakci: "Fit-up value differs from the weld map: welder {0} / {1}.",
        lot: "Fit-up value differs from the weld map: lot {0} / {1}.",
    },
    "WPS-02": "WPS not in Registers: {0} rev {1}.",
    "WM-03": { on_isitma: "Preheat {0} °C is outside {1} (minimum {2} °C).", paso_arasi: "Interpass {0} °C is outside {1} (maximum {2} °C)." },
    "WM-02": "Consumable type {0} differs from lot {1} ({2}).",
    // D-074 Faz 3 · PR 18 (M9-21): kaynağın WPS'inin okunmuş dolgu listesi bu sınıfa ya da ticari ada izin vermiyor.
    "SARF-03": "Consumable class {0} is not allowed by {1}.",
    "WPS-06": "Filler {0} is not on the WPS and has no approval sheet.",
    "WPQ-06": "Welder initials not found: {0}.",
    // D-074 Faz 3 · PR 15 (M7-20): kaynakçının okunmuş yeterliliği bu kaynağın WPS'ini ya da OASIS pasosunun prosesini kapsamıyor.
    "WPQ-03": {
        wps: "Qualification does not cover this weld: WPS {0} (welder {1}).",
        proses: "Qualification does not cover this weld: process {0} (welder {1}).",
    },
    "WM-05": "New part {0} is not in any stock package.",
    "GEN-11": "The job already has a weld map: {0}. Filing this one replaces it; the old file is kept.",
    "GEN-15": "Date cannot be right: {0}.",
    "GEN-09": "Several documents in one file. Check the page ranges.",
};
//# sourceMappingURL=weld-map.js.map